/**
 * Canje del enlace mágico de la demo compartida.
 *
 * El enlace que recibe el prospecto es `…/enter?t=TOKEN`. Ese token es opaco y
 * de un solo prospecto; el servidor solo guarda su hash, así que ni leyendo la
 * base se puede entrar con lo que hay ahí.
 *
 * Canjear NO invalida el enlace. Es deliberado: el prospecto puede volver mañana
 * desde el móvil con el mismo enlace, y esa vuelta es justamente la señal que
 * más pesa después de pulsar "activa tu plataforma" — mide interés sostenido,
 * no una visita larga. Lo que sí caduca es la vigencia de cuatro días.
 */

const API = (import.meta.env.VITE_API_URL ?? '').replace(/\/$/, '')

export type ResultadoCanje =
  | { ok: true; leadId: string; name?: string | null; expiresAt?: string | null }
  | { ok: false; reason: 'invalid' | 'expired' | 'network' }

export async function canjearEnlace(token: string): Promise<ResultadoCanje> {
  if (!token?.trim()) return { ok: false, reason: 'invalid' }

  try {
    const res = await fetch(`${API}/demo/enter`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: token.trim() }),
    })

    if (!res.ok) return { ok: false, reason: 'network' }

    const data = (await res.json()) as ResultadoCanje
    // El servidor responde igual para un token inventado que para uno revocado:
    // no hay motivo para ayudar a distinguirlos.
    if (!data?.ok) return { ok: false, reason: data?.reason === 'expired' ? 'expired' : 'invalid' }
    return data
  } catch {
    return { ok: false, reason: 'network' }
  }
}
